import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Layout } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined, SearchOutlined } from '@ant-design/icons';
import Logo from './Logo';
import NavNotification from './NavNotification';
import NavProfile from './NavProfile';
import NavLanguage from './NavLanguage';
import NavPanel from './NavPanel';
import NavSearch  from './NavSearch';
import SearchInput from './NavSearch/SearchInput.js'
import { toggleCollapsedNav, onMobileNavToggle } from 'redux/actions/Theme';
import { NAV_TYPE_TOP, SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH } from 'constants/ThemeConstant';
import utils from 'utils'
import { Alert  } from 'antd';
import { BASEURL,APIBASEURL } from '../../BaseURL';

import { updateBalance,getBalance } from '../../redux/actions/Theme';
import { GETBALANCE } from '../../redux/constants/Theme';

const { Header } = Layout;

export const HeaderNav = props => {
  const { balance, updateBalance,getBalance, navCollapsed, mobileNav, navType, headerNavColor, toggleCollapsedNav, onMobileNavToggle, isMobile, currentTheme, direction } = props;
  const [searchActive, setSearchActive] = useState(false)

  const onSearchActive = () => {
    setSearchActive(true)
  }

  const onSearchClose = () => {
    setSearchActive(false)
  }

  const onToggle = () => {
    if(!isMobile) {
      toggleCollapsedNav(!navCollapsed)
    } else {
      onMobileNavToggle(!mobileNav)
    }
  }

  const isNavTop = navType === NAV_TYPE_TOP ? true : false
  const mode = ()=> {
    if(!headerNavColor) {
      return utils.getColorContrast(currentTheme === 'dark' ? '#00000' : '#ffffff' )
    }
    return utils.getColorContrast(headerNavColor)
  }
  const navMode = mode()
  const getNavWidth = () => {
    if(isNavTop || isMobile) {
      return '0px'
    }
    if(navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`
    } else {
      return `${SIDE_NAV_WIDTH}px`
    }
  }

  useEffect(() => {    
    // gettopbardata();
    
    // setInterval(() => gettopbardata(), 3000)        
    if(!isMobile) {
      onSearchClose()
    }   
  },[])

  // const [balance, setbalance] = useState();
  const gettopbardata = async () => {
    await updateBalance();
    // console.log(balance);
    // console.log(props);
    // const balance = localStorage.getItem(GETBALANCE)
    // setbalance(balance);

  //   return;
  //   const myHeaders = new Headers();
  //   const userid = localStorage.getItem('userID')
  //   const token = localStorage.getItem('usertoken'); 
  //   // console.log(token);
  //   myHeaders.append('Content-Type', 'application/json');
  //   myHeaders.append('Authorization', token);           
  //   const res = await fetch(BASEURL+'gettopbardata', {
  //       method: "POST",
  //       headers: myHeaders,
  //       body: JSON.stringify({
  //         userID:userid
  //       })
  //   });

  // const data = await res.json(); 
  // if(data.status == 201){
  //   setbalance(data.data[0].balance);
  // }
  // console.log(data);
  }
  

  
  return (
    <Header className={`app-header ${navMode}`} style={{backgroundColor: headerNavColor}}>
      <div className={`app-header-wrapper ${isNavTop ? 'layout-top-nav' : ''}`}>
        <Logo logoType={navMode}/>
        <div className="nav" style={{width: `calc(100% - ${getNavWidth()})`}}>
          <div className="nav-left">
            <ul className="ant-menu ant-menu-root ant-menu-horizontal">          
              {
                isNavTop && !isMobile ?
                null
                :
                <li className="ant-menu-item ant-menu-item-only-child" onClick={() => {onToggle()}}>
                  {navCollapsed || isMobile ? <MenuUnfoldOutlined className="nav-icon" /> : <MenuFoldOutlined className="nav-icon" />}
                </li>
              }
              {
                isMobile ?
                <li className="ant-menu-item ant-menu-item-only-child" onClick={() => {onSearchActive()}}>
                  <SearchOutlined />
                </li>
                :
                <li className="ant-menu-item ant-menu-item-only-child" style={{cursor: 'auto'}}>
                  {/* <SearchInput mode={mode} isMobile={isMobile} /> */}
                </li>
              }
            </ul>

          </div>
          <div className="nav-right">
           {/* {
             balance > 5 ?
             <Alert message={'Balance: $'+balance} type="success" style={{height: '26px',marginTop: '24px','backgroundColor': '#68e9a2'}}/>
             :<Alert message={'Balance: $'+balance} type="error" style={{height: '26px',marginTop: '24px','backgroundColor': '#ff675c'}}/>
           }  */}
            {/* <NavNotification />
            <NavLanguage /> */}
            
            <NavProfile />
            <NavPanel direction={direction} />
          </div>
          {/* <NavSearch active={searchActive} close={onSearchClose}/> */}
        </div>
      </div>
    </Header>
  )
}

const mapStateToProps = ({ theme }) => {
  const { balance, navCollapsed, navType, headerNavColor, mobileNav, currentTheme, direction } =  theme;
  return { balance, navCollapsed, navType, headerNavColor, mobileNav, currentTheme, direction }
};

const mapDispatchToProps = {
  getBalance,
	updateBalance,
  toggleCollapsedNav,
  onMobileNavToggle
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderNav);